<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QnzJhb/tc-custom/9781595588944.jpg?1734332831547" alt="This image is the cover for the book Republic of Outsiders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Republic of Outsiders
      </h1>
      <p class="bookDescription body article font2">
        <b>“Vivid portraits” of individuals and subcultures by a writer who “unmasks the assumptions we make about what counts as normal” (<i>The New York Times</i>).</b><br/>  <br/> They are outsiders who seek to redefine fields from mental health to diplomacy to music. They push boundaries and transform ideas. They include filmmakers crowdsourcing their work, transgender and autistic activists, and Occupy Wall Street’s “alternative bankers.” These people create and package themselves in a practice cultural critic Alissa Quart dubs “identity innovation.”<br/>  <br/> In this “fascinating” book, Quart introduces us to individuals who have created new structures to keep themselves sane, fulfilled, and, on occasion, paid. This deeply reported book shows how these groups now gather, organize, and create new communities and economies. Without a middleman, freed of established media, and highly mobile, unusual ideas and cultures are able to spread more quickly and find audiences and allies. <i>Republic of Outsiders</i> is a critical examination of those for whom being rebellious, marginal, or amateur is a source of strength (Barbara Ehrenreich).<br/>  <br/> “Even if you don’t consider yourself an outsider or a rebel, Quart’s book has several lessons for creative work, particularly when it comes to making art outside a heavily commercial system.” —<i>Fast Company</i><br/>  <br/> “One of the smartest cultural interpreters of her generation. In <i>Republic of Outsiders</i>, she mixes sharp-eyed analysis with an empathetic heart. The result is a great read, and a brand-new lens through which to view outsiders, insiders—and ourselves.” —Susan Cain, author of <i>Quiet: The Power of Introverts in a World That Can’t Stop Talking</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alissa Quart
      </h2>
      
      <p class="authorDescription body article">Alissa Quart is an American nonfiction writer, critic, journalist, editor, and poet. Her nonfiction books are Republic of Outsiders: The Power of Amateurs, Dreamers and Rebels, and Hothouse Kids: The Dilemma.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?659cb852